import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import MUIDataTable from 'mui-datatables';

import PatientSearchFilters from './PatientSearchFilters';
import ImportPatientForm from './ImportPatientForm';
import LoadingPageText from '../../../components/common/Loading/LoadingPageText';

import { useFetchPatientSearch } from '../../../actions/entities/patients/fetchHooks';
import { tableSettings } from './patientSearchTableSettings';
import { eventHandlers } from './patientSearchHandler';
import { PATIENT_GET_FAILURE } from '../../../actions/constants/types';

import { getDateForApi } from '../../../utils/dates';

export default function PatientSearchPage() {
  document.title = 'Patient Search';

  const dispatch = useDispatch();
  const [state, setState] = useState({
    forceReload: false,
    forename: '',
    surname: '',
    nhsNumber: '',
    dateOfBirth: '',
    postCode: '',
    status: 1,
    currentPage: 1,
    pageSize: 15,
    sortColumn: 'Surname',
    sortDirection: 'asc',
    showImportSidePanel: false,
  });
  const convertStatusToBool = status => {
    return status === 0 ? null : status === 1;
  };
  const getModel = {
    forceReload: state.forceReload,
    forename: state.forename,
    surname: state.surname,
    nhsNumber: state.nhsNumber,
    dateOfBirth: getDateForApi(state.dateOfBirth),
    postCode: state.postCode,
    isActiveInECommunity: convertStatusToBool(state.status),
    currentPage: state.currentPage,
    pageSize: state.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
  };
  const { data, isDataLoading, auth, error, isTableDataLoading } = useFetchPatientSearch(getModel);

  const events = eventHandlers(state, setState, auth);

  if (isDataLoading)
    return <LoadingPageText showHeader={false}>Wait a moment while we gather patients info...</LoadingPageText>;

  if (error && error.message) dispatch({ type: PATIENT_GET_FAILURE, message: error.message });

  const settings = tableSettings({
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: events,
    isTableDataLoading,
  });

  return (
    <React.Fragment>
      <PatientSearchFilters
        onSubmit={events.onFiltersChange}
        errorProps={error ? error.props : []}
        events={events}
        isTableDataLoading={isTableDataLoading}
      />
      <div className="page-content-wrapper">
        <MUIDataTable
          id="patient-search-table"
          title={settings.name}
          data={data.items}
          columns={settings.columns}
          options={settings.options}
        />
      </div>

      {state.showImportSidePanel && <ImportPatientForm events={events} />}
    </React.Fragment>
  );
}
